//制造业重大项目方向

const indexAdmin = () => import('./indexAdmin');
const indexAppl = () => import(/* webpackChunkName: "herb" */ './indexAppl');
const edit = () => import('./edit.vue');

export default {
  routes: [
    {
      path: '/renovation/v2024/indexAppl',
      name: 'renovation_v2024_index_appl',
      component: indexAppl,
      meta:{public:true}
    },
    {
      path: '/renovation/v2024/indexAdmin',
      name: 'renovation_v2024_index_admin',
      component: indexAdmin,
      meta: {public: true}
    },
    {
      path: '/renovation/v2024/edit',
      name: 'renovation_v2024_edit',
      component: edit,
      meta: {public: true}
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/smes/renovation/v2024/router.js